import Reflux from 'reflux';
import moment from 'moment-timezone';
import { Client } from 'api';
import EventActions from 'actions/eventActions';

export default class EventStore extends Reflux.Store {
    constructor() {
        super();

        this.client = new Client();

        this.listenables = EventActions;
        this.state = {
            event: {},
        };
    }

    onLoadEvent(event) {
        this.setState({ event: event });
    }

    onUpdateEvent(event) {
        if (event.date) {
            event.date = moment(event.date);
        }

        if (event.start_date) {
            event.start_date = moment(event.start_date);
        }

        if (event.end_date) {
            event.end_date = moment(event.end_date);
        }

        this.setState({ event: event });
    }

    onSeenVendorTutorial() {
        this.client.request(`/api/events/${this.state.event.id}/seen_modal`, {
            method: 'POST',
        });
    }

    onPaidFor() {
        const event = this.state.event;
        event.paid_for = true;

        this.setState({ event: event });
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/stores/eventStore.jsx